// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cBa8","colMin":"styles_colMin__1JvRR"};